import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sidePanelPackagesLabel: {
    defaultMessage: '{count, plural, one {Package} other {Packages}}',
    description: 'Label for package count badge in the summary panel. Shows singular "Package" for 1, plural "Packages" for multiple.',
    id: 'ITd/cT',
  },
  sidePanelTotalWeightLabel: {
    defaultMessage: 'Total Weight',
    description: 'Label for total weight sum of all packages in the summary panel',
    id: 'NiMlvV',
  },
  sidePanelTotalInsuranceLabel: {
    defaultMessage: 'Total Insurance',
    description: 'Label for total insurance value sum of all packages in the summary panel',
    id: 'PQarRg',
  },
});
